// api/axiosClient.js
import axios from 'axios';
import AppConfigs from 'general/constants/AppConfigs';
import AppRoute from 'general/constants/AppRoute';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import ToastHelper from 'general/helpers/ToastHelper';
import Utils from 'general/utils/Utils';
import { t } from 'i18next';
import queryString from 'query-string';
import _ from 'lodash';

const axiosClient = axios.create({
  baseURL: AppConfigs.env.apiUrl,
  headers: {
    'content-type': 'application/json',
    'Cache-Control': 'no-cache',
  },
  paramsSerializer: (params) => queryString.stringify(params),
});

axiosClient.interceptors.request.use(async (config) => {
  return config;
});

axiosClient.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }

    return response;
  },
  (error) => {
    let errorMessage = null;
    const response = error.response;
    if (response && response.status === 401) {
      // ToastHelper.showError(t('message401error'));
      // AuthHelper.signOut();
      localStorage.removeItem(PreferenceKeys.accessToken);
      localStorage.removeItem(PreferenceKeys.accessTokenExpired);
      localStorage.removeItem(PreferenceKeys.savedActiveRole);
      delete axiosClient.defaults.headers.common['Authorization'];
      if (!window.location.pathname.includes(AppRoute.auth)) {
        Utils.openInCurrentTab(AppRoute.auth);
      }
    }

    if (response && response.data) {
      const data = response.data;
      const { result, reason, detail } = data;
      if (result === 'failed') {
        if (reason) {
          errorMessage = reason;
        } else if (detail) {
          errorMessage = detail;
        }
      }
    }
    if (errorMessage) {
      // ToastHelper.showError(errorMessage);
    }
    throw error;
  }
);

// Update base url
const updateAxiosBaseURL = (baseUrl) => {
  axiosClient.defaults.baseURL = baseUrl;
};

// Update access token
const updateAxiosAccessToken = (accessToken) => {
  axiosClient.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
};

// Remove access token
const removeAxiosAccessToken = () => {
  delete axiosClient.defaults.headers.common['Authorization'];
};

(() => {
  const isTokenValid = !_.isUndefined(localStorage.getItem(PreferenceKeys.accessToken)) && !_.isNull(localStorage.getItem(PreferenceKeys.accessToken));
  if (isTokenValid) {
    const token = localStorage.getItem(PreferenceKeys.accessToken);
    updateAxiosAccessToken(token);
  }
})();

export { removeAxiosAccessToken, updateAxiosAccessToken, updateAxiosBaseURL };

export default axiosClient;
